import {
  createStyles,
  Grid,
  Paper,
  type WithStyles,
  withStyles,
} from "@material-ui/core";
import { useAnalytics } from "adapters/analytics";
import { ConfigurationItem } from "constants/configurations";
import { PortalRoutes } from "constants/routes";
import history from "features/app/History";
import React, { useEffect } from "react";
import { AppBar, AppBarConteudoDefault } from "../../layout";
import { SelectedFarmContainer } from "../../shared/crossCuttingComponents";
import { FarmBenchmarkCardContainer } from "../components/farmBenchmarkCard";
import {
  ConfigurationItemsVisibility,
  FeaturesVisibility,
} from "../configurations.types";
import { useConfigurationFeatures } from "../hooks/useConfigurationFeatures";
import { useConfigurationItems } from "../hooks/useConfigurationItems";
import ConfigurationCard from "./configurationCard";
import FeaturesDropdown from "./featuresDropdown";

type ConfigurationsContentProps = {
  featuresVisibility: FeaturesVisibility;
  itemsVisibility: ConfigurationItemsVisibility;
  onSelectRegistrationItem: (id: ConfigurationItem) => void;
} & WithStyles<typeof styles>;

function ConfigurationsContent({
  classes,
  featuresVisibility,
  itemsVisibility,
  onSelectRegistrationItem,
}: ConfigurationsContentProps) {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.trackPageView(PortalRoutes.CONFIGURATIONS, {
      pageTitle: "Configurações",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    featureItems,
    handleChangeFeature,
    selectedFeature,
    selectedFeatureItem,
  } = useConfigurationFeatures({ featuresVisibility });

  const { configurationItems } = useConfigurationItems({
    itemsVisibility,
    selectedFeature,
  });

  const handleItemClick = (id: ConfigurationItem) => {
    onSelectRegistrationItem(id);
    history.push(PortalRoutes.CONFIGURATIONS_REGISTRATIONS);
  };

  return (
    <React.Fragment>
      <AppBar
        conteudoCustomizadoAppBar={
          <SelectedFarmContainer
            render={(farm, { noFarmSelectedTitle }) => (
              <AppBarConteudoDefault
                tituloAppBar={farm?.NomeReduzido ?? noFarmSelectedTitle}
              />
            )}
          />
        }
      />
      <Paper square className={classes.paper}>
        <Grid container alignItems="center">
          <div className={classes.contentRoot}>
            <div className={classes.contentWrapper}>
              <Grid item xs={12}>
                <FeaturesDropdown
                  items={featureItems}
                  onFeatureChange={handleChangeFeature}
                  selectedFeature={selectedFeature}
                  selectedFeatureItem={selectedFeatureItem}
                />
              </Grid>
              <div className={classes.cardItemsContainer}>
                <FarmBenchmarkCardContainer />
                {configurationItems.map((item) => (
                  <div className={classes.cardItem} key={item.id}>
                    <ConfigurationCard
                      item={item}
                      onItemClick={handleItemClick}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Grid>
      </Paper>
    </React.Fragment>
  );
}

const styles = () =>
  createStyles({
    paper: {
      minHeight: "calc(100vh - 65px)",
    },
    contentRoot: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
    },
    contentWrapper: {
      width: "86%",
      display: "flex",
      flexDirection: "column",
    },
    cardItemsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    },
    cardItem: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "1rem",
    },
  });

export default withStyles(styles)(ConfigurationsContent);
